/**
 * Use the global Drupal object.
 * @returns {object}
 */
export function useDrupal() {
  return window.Drupal || {};
}

/**
 * Use the global jQuery object.
 * @returns {object}
 */
export function useJQuery() {
  return window.jQuery || {};
}

/**
 * Use the global drupalSettings object.
 * @returns {object}
 */
export function useDrupalSettings() {
  return window.drupalSettings || {};
}

/**
 * Test if we are on the production environment.
 * @returns {boolean}
 */
export function isProd() {
  return window.drupalSetting.isProd;
}
